import { numberToPrettyString } from '@cian/utils';

import { IPrice, ECurrency, EPeriod } from '../../types/price';

export const currencyToString = (currency: ECurrency) => {
  switch (currency) {
    case ECurrency.Eur:
      return '€';
    case ECurrency.Usd:
      return '$';
    case ECurrency.Rur:
    default:
      return '₽';
  }
};

export const periodToString = (period?: EPeriod | null): string | null => {
  switch (period) {
    case EPeriod.Day:
      return 'сутки';
    case EPeriod.Month:
      return 'мес.';
  }

  return null;
};

export const priceToString = (price: IPrice): string => {
  const { value, currency, period } = price;
  const formattedValue = numberToPrettyString(value);
  const currencySymbol = currencyToString(currency);
  const periodString = period ? `/${periodToString(period)}` : null;

  return `${formattedValue} ${currencySymbol}${periodString || ''}`;
};
